import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { DrawerHeader } from 'components/drawer-header'
import { setDrawer, setHeaderVisibility } from 'slices/drawer'
import { DRAWER_KEY } from 'app-constants'
import { DETAILS_SVA_STAGES } from './constants'
import { DetailsSva, IntegrationError } from './components'

function stages(props) {
  return {
    [DETAILS_SVA_STAGES.INITIAL]: <DetailsSva {...props} />,
    [DETAILS_SVA_STAGES.INTEGRATION_ERROR]: <IntegrationError />,
  }
}

export function DetailsSvaDrawer() {
  const { stage, data } = useSelector(({ drawer }) => drawer)
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(setHeaderVisibility(false))
  }, [dispatch])

  function handleDrawerClose() {
    dispatch(setDrawer(DRAWER_KEY.NONE))
  }

  function renderContent() {
    return stages(data)[stage]
  }

  return (
    <>
      <DrawerHeader title='Serviços Digitais' onClose={handleDrawerClose} />
      {renderContent()}
    </>
  )
}
